export default "__VITE_ASSET__DfAupNhB__"